module.exports = __webpack_public_path__ + "img/icon_plus.2000cd2a.png";